/** Do not rename: persisted key used across sessions / legacy data. */
const STORAGE_KEY = 'STATUS_LOAD_FILE';

export const loadOperationLoadFileStatus = (): string =>
  localStorage.getItem(STORAGE_KEY) || '';

export const saveOperationLoadFileStatus = (status: string): void => {
  localStorage.setItem(STORAGE_KEY, status);
};
